import { render, staticRenderFns } from "./Demand.vue?vue&type=template&id=69fb156d&scoped=true&"
import script from "./Demand.vue?vue&type=script&lang=js&"
export * from "./Demand.vue?vue&type=script&lang=js&"
import style0 from "./Demand.vue?vue&type=style&index=0&id=69fb156d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fb156d",
  null
  
)

export default component.exports